﻿import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CreateActivityDateViewModel } from '../ViewModels/ActivityDateViewModel';
import CircularProgress from '@mui/material/CircularProgress';
import authService from '../api-authorization/AuthorizeService';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonProgress: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        }
    })
);

interface IActivityProps {
    accountId: number;
    activityId?: number;
    date: Date;
    open: boolean;
    close: (refresh: boolean) => void;
}

export default function ConnectionDialog(props: IActivityProps) {
    const classes = useStyles();
    const [activity, setActivity] = React.useState<CreateActivityDateViewModel>({id: 0, accountId: props.accountId, date: props.date, messages: 0, connections: 0 });
    const [submitting, setSubmitting] = React.useState(false);
    const [error, setError] = React.useState('');

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setActivity({
            ...activity,
            [event.target.name]: event.target.valueAsNumber || event.target.value
        });
    }

    const onClose = () => {
        if (!submitting) {
            setActivity({ id: props.activityId, accountId: props.accountId, date: props.date, messages: 0, connections: 0 });
            props.close(false);
        }
    }

    const submit = async () => {
        setSubmitting(true);
        const token = await authService.getAccessToken();

        setActivity({
            ...activity,
            date: props.date,
            id: props.activityId
        })

        fetch('Account/CreateActivityDateConnections', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(activity)
        })
            .then(response => response.text())
            .then(data => {
                setSubmitting(false);
                props.close(true);
            })
            .catch(error => {
                setError('A server error has occurred, please try again.');
            });
    }

    return (
        <Dialog open={props.open} aria-labelledby="form-dialog-title">
            <ValidatorForm onSubmit={submit}>
                <DialogTitle id="form-dialog-title">Log Activity</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Log your connections on this account for {new Date(props.date).toLocaleDateString("en-GB")}.
                        {error}
                    </DialogContentText>
                    <Grid container spacing={2}>
                        <Grid item>
                            <TextValidator
                                fullWidth
                                autoFocus
                                variant="outlined"
                                margin="dense"
                                label="Connections"
                                type="number"
                                name="connections"
                                value={activity.connections}
                                onChange={onChange}
                                validators={['required', 'isNumber', 'minNumber: 1']}
                                errorMessages={['Required', 'Must be a number greater than 0', 'Must be a number greater than 0']}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary" disabled={submitting}>Cancel</Button>
                    <Button type="submit" color="primary" disabled={submitting}>
                        Submit
                    {submitting && <CircularProgress color='primary' size={24} className={classes.buttonProgress} />}
                    </Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>
    );
}